<template>
    <div class="addprojectwrapper">
    <div class="addprojectinputform">
      <div class="div-block-18" v-show="show_form">
        <div class="addprojectformtitle">Add a Project
            <a href="#" class="link-block-6 w-inline-block"
              @click="$emit('close-add-project-form')">
              <img src="../../static/images/cancel.png" width="32" height="32" class="image-6">
            </a>
        </div>
        <div class="div-block-17">
          <div class="text-block-11">Project Name</div>
          <div style="margin-top:8px;">
            <el-input
              placeholder="Enter Project Name"
              v-model="project_name"
              clearable>
            </el-input>
            <div v-show="duplicate_name" style="color:#c62828;">This name is unavailable due to the project id already exists, try another name.</div>
            <div v-show="show_validate && project_name === ''" style="color:#c62828;">Please enter a project name</div>
          </div>
          <div class="text-block-11" style="margin-top:">Project ID: {{ project_id }}</div>
          <div class="text-block-client">Client Name</div>
          <div style="margin-top:8px;">
            <el-input
              placeholder="Enter Client Name"
              v-model="client_name"
              clearable>
            </el-input>
            <div v-show="show_validate && client_name === ''" style="color:#c62828;">Please enter client's name</div>
          </div>
          <div class="text-block-11">Client Address</div>
          <div style="margin-top:8px;">
            <el-input
              placeholder="Enter Project Address"
              v-model="project_address"
              clearable>
            </el-input>
            <div v-show="show_validate && project_address === ''" style="color:#c62828;">Please enter project address</div>
          </div>
          <div class="text-block-11">Client's Contact Info</div>
          <div style="margin-top:8px;">
            <el-input
              placeholder="Enter Project Address"
              v-model="contact_info"
              clearable>
            </el-input>
            <div v-show="show_validate && contact_info === ''" style="color:#c62828;">Please enter a contact info</div>
          </div>
        </div>
      </div>
      <div class="div-block-19" v-show="show_form">
        <a href="#" class="link-block-5 w-inline-block">
          <div class="div-block-20">
            <el-button type="primary" round
              @click="createProject()">Create</el-button>
          </div>
        </a>
      </div>
      <AddProjectLoader v-if="loading" @finish-loading="cleanUp"></AddProjectLoader>
    </div>
  </div>
</template>

<script>
import { db } from '../main'
import AddProjectLoader from './AddProjectLoader.vue'

export default {
  name: 'AddProjectForm',
  data () {
    return {
      project_name: '',
      client_name: '',
      project_address: '',
      contact_info: '',
      show_form: true,
      loading: false,
      show_validate: false
    }
  },
  props: ['exist_project'],
  computed: {
    duplicate_name: function () {
      if (this.exist_project.indexOf(this.project_id) !== -1) {
        return true
      } else {
        return false
      }
    },
    project_id: function () {
      // slash is not allowed in id
      return this.project_name.replace(/\//g, '\\').replace(/ /g, '-').toLowerCase()
    }
  },
  methods: {
    createProject: function () {
      this.show_validate = true
      let valid = true
      if (this.project_id === '' || this.client_name === '' || this.project_address === '' || this.contact_info === '') {
        valid = false
      }
      if (this.duplicate_name) {
        valid = false
      }
      if (valid) {
        let date = new Date()
        let month = String(date.getMonth() + 1)
        if (month.length < 2) {
          month = '0' + month
        }
        let day = String(date.getDate() + 1)
        if (day.length < 2) {
          day = '0' + day
        }
        let year = String(date.getFullYear())
        let formatDate = year + '-' + month + '-' + day

        let newProject = {
          name: this.project_name,
          client: this.client_name,
          address: this.project_address,
          contact: this.contact_info,
          id: this.project_id,
          last_open_date: formatDate,
          create_date: formatDate,
          status: 'open',
          version: 2
        }
        // console.log('create new project: ' + newProject.name)
        db.collection('project_list').doc(newProject.id).set(newProject)
        db.collection('project').doc(newProject.id).set(newProject)
        this.loading = true
        this.show_form = false
      }
    },
    cleanUp: function () {
      // console.log('cleaning up')
      let projectId = this.project_id // used to navigate after cleaning up
      this.project_name = ''
      this.client_name = ''
      this.project_address = ''
      this.contact_info = ''
      this.show_form = true
      this.loading = false
      this.show_validate = false
      this.$emit('close-add-project-form')
      this.$router.push({
        path: 'dashboard',
        query: {
          project: projectId
        }
      })
    }
  },
  components: {
    AddProjectLoader
  }
}
</script>



// WEBPACK FOOTER //
// src/components/AddProjectForm.vue